// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"_3yVKe","subTitleText":"xxv53","tableView":"_2vYlG","tableHeaderStrip":"_3B0VF","ctaText":"_2XJub"};